<template>
    <div class='container'>
        <div v-for="delivery_method in delivery_methods" :key="delivery_method.id">
            <div class='heading'>{{delivery_method.label}}</div>
            <div v-html="delivery_method.description"></div>
        </div>
        <!-- <div class='stock-checker-section'>
            <div class='heading'>Check Available Stock</div>
            <div class='stock-checker-container'>
                <input class='post-code-checker' type="text" id="reviews_search_bar" name="reviews-search-bar" placeholder="Postcode" >
                <Button text='Check Stock' @click='checkStock'/>
            </div>
        </div> -->
    </div>
</template>

<script>
import {checkAuth} from "@/global/modules/functions.js";
import Button from '@/ecom/components/buttons/Button.vue'

export default {
    components: {Button},
    data(){
        return{
            delivery_methods: []
        }
    },
    methods:{
        checkStock(){

        },
        async getDeliveryMethods() {
            let response = await fetch(`/api/delivery-methods/delivery-info`, {
                method: 'GET',
                credentials: 'include'
            });

            let results = await checkAuth(response);
            
            if (response.status === 200){
                this.delivery_methods = results.delivery_methods;
            }
        }
    },
    beforeMount() {
        this.getDeliveryMethods();
    }
}
</script>
<style lang="scss" scoped>

.container{
    display: flex;
    flex-direction: column;
    gap: 10px;
    margin-left: 10px;
}

.heading{
    font-weight: 600;
    letter-spacing: 0.5px;
    line-height: 30px;
    color: var(--black);
}

.stock-checker-section{
    margin-top: 10px;
}

.stock-checker-container{
    display: flex;
    gap: 30px;
}

.post-code-checker{
    width: 200px;
    height: 40px;
    border-radius: 2px;
    border: solid 0.5px #dee2e6;
    padding: 1px 35px 1px 20px;
    font-size: 1rem;
    font-size: 0.9rem;
}

</style>